import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import type { GetTestConfigsResponse } from '@eggplant/types'

export interface Props {
  webhook_id: string
  onSuccess: (testConfigs: GetTestConfigsResponse) => void
}

const GetWebhookTestConfigRequest = ({
  webhook_id,
  onSuccess
}: Props) => {
  const params = { webhook_id }
  const url = TEST_CONFIG_SERVICE + '/test_configurations'

  return (
    <AuthenticatedDataRequest
      method='get'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetWebhookTestConfigRequest
